import cx from "classnames";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { VoteProgress } from "@/appInterface/windows/VoteProgress";
import style from "./EndVote.module.css";

export function EndVote({ endHandler, closeModal, progress, voters }) {
    const { t } = useTranslation();
    const [isProgressOpen, setIsProgressOpen] = useState(false);
    const handleShowVoteProgress = () => {
        setIsProgressOpen((prev) => !prev);
    };

    const allVoted = progress.fullyVotedMembersCount === progress.membersVoteCount;

    return (
        <div className={style.modal} style={{ width: allVoted ? "340px" : "380px" }}>
            <div className={style.header}>
                <p className={style.title}>{t("vote.endTitle")}</p>
                <button
                    onClick={closeModal}
                    className={cx(style.close, style.button, "button--close")}
                    type="button"
                    aria-label={t("common.close")}
                />
            </div>

            <div className={style.main}>
                <p className={style.description}>
                    {allVoted ? t("vote.endDescription2") : t("vote.endDescription1")}
                </p>
                {!allVoted && (
                    <div className={style.progressWrapper}>
                        <VoteProgress
                            progress={progress}
                            isOpen={isProgressOpen}
                            onToggle={handleShowVoteProgress}
                            voters={voters}
                        />
                    </div>
                )}
            </div>

            <div className={style.buttons}>
                <button
                    onClick={() => endHandler()}
                    className={allVoted ? style.complete : style.back}
                    style={{ width: allVoted ? "132px" : "152px" }}
                    aria-label={t("vote.endAction")}
                    type="button"
                >
                    {t("vote.endAction")}
                </button>
                <button
                    onClick={() => closeModal()}
                    className={allVoted ? style.back : style.complete}
                    style={{ width: allVoted ? "132px" : "152px" }}
                    aria-label={t("vote.backAction")}
                    type="button"
                >
                    {t("vote.backAction")}
                </button>
            </div>
        </div>
    );
}
